import { OKENDO_STORE_URL, OKENDO_WRITE_REVIEW_URL } from '~/lib/constants';
import { generateStarRating } from '~/lib/helpers';
import { defineElement } from '~/utils/gw-utils';
import { ReviewsOverview } from './reviews-overview';

const PRODUCT_REVIEW_OVERVIEW_API = `/products/shopify-[product_id]/review_aggregate`;

const attributes = {
  productId: 'data-product-id',
  writeReviewButton: 'data-write-review-button',
};

class ProductReviewsOverview extends ReviewsOverview {
  constructor() {
    super();
    this.productId = encodeURIComponent(this.getAttribute(attributes.productId));
    this.$writeReviewButton = document.querySelector(`[${attributes.writeReviewButton}]`);
  }

  async connectedCallback() {
    const productReviewsOverview = await this.fetchReviewsOverview(this.generateUrl(this.productId));

    this.renderReviewsOverview(productReviewsOverview);
    this.setWriteReviewButtonHref(this.productId);

    window.addEventListener('url:changed', async (event) => {
      const productId = event.detail.productId;
      const productReviewsOverview = await this.fetchReviewsOverview(this.generateUrl(productId));

      this.renderReviewsOverview(productReviewsOverview);
      this.setWriteReviewButtonHref(productId);
    });
  }

  setWriteReviewButtonHref(productId) {
    const writeReviewUrl = OKENDO_WRITE_REVIEW_URL.replace('[product-id]', encodeURIComponent(productId));
    this.$writeReviewButton.href = writeReviewUrl;
  }

  generateUrl(productId) {
    return `${OKENDO_STORE_URL + PRODUCT_REVIEW_OVERVIEW_API.replace('[product_id]', productId)}`;
  }
}

defineElement('product-reviews-overview', ProductReviewsOverview);
